<div class="container-fluid">
    <div class="row modal-header">
        <div class="col">
            <h6>{{ 'TERMS_AND_CONDITION.HEADING.TERMS_CONDITION' | transloco }}</h6>
        </div>
    </div>
    <div class="row terms-modal-body d-flex flex-column justify-content-start" #modal_body (scroll)="scrollHandler()">
        <input type="text" ngbAutoFocus style="display: none" />
        <div class="col">
            <div>
                <p>
                    <strong>
                        {{ 'TERMS_AND_CONDITION.CONDITIONS.INFO_1' | transloco }}
                    </strong>
                </p>
            </div>
            <div>
                <p>
                    {{ 'TERMS_AND_CONDITION.CONDITIONS.INFO_2' | transloco }}
                </p>
            </div>
            <div>
                <h6>{{ 'TERMS_AND_CONDITION.HEADING.CONDITIONS' | transloco }}</h6>
            </div>
            <div class="terms-list" *transloco="let t; read: 'TERMS_AND_CONDITION.CONDITIONS'">
                <ng-container>
                    <ol>
                        <li>
                            <p>{{ t('CONDITION_1') }}</p>
                        </li>
                        <li>
                            <p>{{ t('CONDITION_2') }}</p>
                        </li>
                        <li>
                            <p>{{ t('CONDITION_3') }}</p>
                        </li>
                        <li>
                            <p>{{ t('CONDITION_4') }}</p>
                        </li>
                        <li>
                            <p>{{ t('CONDITION_5') }}</p>
                        </li>
                        <li>
                            <p>{{ t('CONDITION_6') }}</p>
                        </li>
                        <li>
                            <p>{{ t('CONDITION_7') }}</p>
                        </li>
                        <li>
                            <p>{{ t('CONDITION_8') }}</p>
                        </li>
                        <li>
                            <p>{{ t('CONDITION_9.MAIN_INFO') }}</p>
                            <ol type="a">
                                <li>{{ t('CONDITION_9.SUB_INFO_1') }}</li>
                                <li>{{ t('CONDITION_9.SUB_INFO_2') }}</li>
                                <li>{{ t('CONDITION_9.SUB_INFO_3') }}</li>
                            </ol>
                        </li>
                        <li>
                            <p>{{ t('CONDITION_10') }}</p>
                        </li>
                    </ol>
                </ng-container>
                <h6>{{ 'TERMS_AND_CONDITION.HEADING.GENERAL' | transloco }}</h6>
                <ol *transloco="let t; read: 'TERMS_AND_CONDITION.GENERAL_INFO'">
                    <li>{{ t('INFO_1') }}</li>
                    <li>{{ t('INFO_2') }}</li>
                    <li>{{ t('INFO_3') }}</li>
                    <li>{{ t('INFO_4') }}</li>
                    <li>{{ t('INFO_5') }}</li>
                </ol>
            </div>
            <div>
                <h6>{{ 'TERMS_AND_CONDITION.HEADING.PRIVACY_POLICY' | transloco }}</h6>
            </div>
            <div *transloco="let t; read: 'TERMS_AND_CONDITION.GENERAL_TEXT.PRIVACY_POLICY_INFO'">
                <p>
                    {{ t('PART_1') }} <a target="_blank" href="{{ t('URL') }}"> {{ t('URL') }}</a>
                    {{ t('PART_2') }}
                </p>
            </div>
            <div>
                <p>
                    <strong>{{ 'TERMS_AND_CONDITION.GENERAL_TEXT.REVISED' | transloco }} </strong>
                    {{ 'TERMS_AND_CONDITION.GENERAL_TEXT.DATE' | transloco }}
                </p>
            </div>
        </div>
    </div>
    <div class="row modal-footer">
        <div class="col">
            <div class="row checkbox-wrapper">
                <div class="col">
                    <mat-checkbox class="example-margin" [formControl]="checkbox">
                        {{ 'TERMS_AND_CONDITION.GENERAL_TEXT.CONFIRMATION_MESSAGE' | transloco }}
                    </mat-checkbox>
                </div>
                <div class="col" *ngIf="checkbox.value == false && checkbox.dirty">
                    <span>Please check the checkbox!</span>
                </div>
            </div>
        </div>
        <div class="col d-flex justify-content-end">
            <button type="button" class="btn primary-ebtn me-3" (click)="acceptButtonsClick()" [disabled]="disabledControl">
                {{ 'TERMS_AND_CONDITION.GENERAL_TEXT.ACCEPT_BUTTON' | transloco }}
            </button>
        </div>
    </div>
</div>
